var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.layout === 'Cassa')?_c('the-cassa-layout'):(_vm.layout==='Default')?_c('the-default-layout'):_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }